const eventServices = angular.module('eventServices', []);

eventServices.service('eventService', function(
  $rootScope,
  $interval,
) {
  const events = $rootScope.$new(true);
  let since = null;
  let lastFleetStatusLoad = DateTime.now();
  let lastFleetStatusLoadPromise;

  on('userservice:authorized', function() {
    since = null;
    lastFleetStatusLoadPromise = $interval(triggerFleetStatusLoad, 5000);
  });

  on('userservice:unauthorized', function() {
    $interval.cancel(lastFleetStatusLoadPromise);
  });

  //Secure that fleet status updates, even if all trains are offline for some reason.
  function triggerFleetStatusLoad() {
    if (lastFleetStatusLoad.diffNow('seconds').seconds < -5) {
      trigger('FLEET_STATUS', 'FLEET_STATUS');
    }
  }

  function on(key, callback) {
    return events.$on(key, callback);
  }

  function trigger(key, object) {
    if (object === 'FLEET_STATUS') {
      lastFleetStatusLoad = DateTime.now();
    }
    events.$emit(key, object);
  }

  function broadcast(object, args) {
    events.$broadcast(object, args);
  }

  function triggerEvents(events) {
    _.each(events, function(event) {
      trigger(event, event);
    });
  }

  return {
    on: on,
    trigger: trigger,
    broadcast: broadcast,
  };
});

eventServices.service('toasterService', function(toaster, $translate) {
  function error(title, message) {
    toaster.error($translate.instant(title), $translate.instant(message));
  }

  function pop(message) {
    toaster.pop($translate.instant(message));
  }

  function success(title, message) {
    toaster.success($translate.instant(title), $translate.instant(message));
  }

  function warning(title, message) {
    toaster.warning($translate.instant(title), $translate.instant(message));
  }
  function warningWithTimeout(title, message, timeout) {
    toaster.pop({
      type: 'warning',
      title: title,
      body: message,
      timeout: timeout,
    });
  }

  return {
    error: error,
    pop: pop,
    success: success,
    warning: warning,
    warningWithTimeout: warningWithTimeout,
  };
});
